<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="ctrPublicId" v-model="searchParams.ctrPublicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="ctrPublicId">관할행정</label>
                    </div>
                    <div class="p-field-0 p-float-label m-2" style="width: 8rem">
                        <Calendar v-model="searchParams.sDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>시작일자</label>
                    </div>
                    <label style="padding-left: 0.2em; padding-right: 0.2em; line-height: 54px;">~</label>
                    <div class="p-field p-float-label m-2" style="width: 8rem">
                        <Calendar v-model="searchParams.eDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>종료일자</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>

        <DataTable id="dt" ref="dt" :value="dataList" showGridlines
            rowIndexVar="rowIndex" :loading="loading"
            scrollable="true" scrollHeight="79vh" class="p-datatable-sm" responsiveLayout="scroll">
            <ColumnGroup type="header">
                <Row>
                    <Column field="rowNo" header="No" :rowspan="2" headerStyle="width:3em"></Column>
                    <Column field="ctrPublicId" header="관할행정구역" :rowspan="2">
                        <template #body="{data}">
                            {{(publicCodes.find(e=>e.code == data.ctrPublicId)||{codeNm:""})['codeNm']}}
                        </template>
                    </Column>
                    <Column field="corpId" header="업체ID" :rowspan="2"></Column>
                    <Column field="corpNm" header="업체명" :rowspan="2"></Column>
                    <Column field="getTot" header="수입" :rowspan="2"></Column>
                    <Column header="지출" :colspan="3"></Column>
                    <Column field="profit" header="차액(수입-지출)" :rowspan="2"></Column>
                </Row>
                <Row>
                    <Column field="gasUnitCost" header="유류대"></Column>
                    <Column field="expAmt" header="비용"></Column>
                    <Column field="totAmt" header="합계"></Column>
                </Row>
            </ColumnGroup>
            <Column field="rowNo" header="No" style="min-width:3em; max-width:3em" exportFooter=" "></Column>
             <Column field="ctrPublicId" header="관할행정구역" exportFooter=" ">
                <template #body="{data}">
                    {{(publicCodes.find(e=>e.code == data.ctrPublicId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="corpId" header="업체ID" exportFooter=" "></Column>
            <Column field="corpNm" header="업체명" exportFooter=" "></Column>
            <Column field="getTot" header="수입" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="gasUnitCost" header="유류대" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="expAmt" header="비용" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="totAmt" header="합계" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="profit" header="차액(수입-지출)" :sortable="false" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import CodeService from '@/service/cm/CodeService';
import MA601040Service from '@/service/ma/MA601040Service';
import CustService from '@/service/ma/CustService';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';

export default {
    setup() {
        onMounted(() => {
            searchParams.compSeq = 1;

            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '') {
                    searchParams.publicId = user.publicId;  // 업체소재지
                    isCustUser.value = true;
                }
            }

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let sDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.sDate = JsUtils.getDateString(sDate);            
            searchParams.eDate = JsUtils.getDateString(new Date());          // 현재 일자

            year.value = new Date().getFullYear();
            calcYms.value = Array.from({ length: year.value - 2010 + 1 }, (_, i) => ({ codeNm: `${year.value - i}`, code: year.value - i }));

            codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
            codeService.getCodeList({ compSeq:1, upCode:'_rpt_tag'}).then(data=> rptTags.value = data);  // 신고분류 코드

            custService.getCodeList(searchParams).then(data => {
                corps.value = data;
            });
        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const ma601040Service = new MA601040Service();
        const custService = new CustService();
        const searchParams = reactive({publicId:null, custSeq:null, rptTag:null, sDate:null, eDate:null});
        const dataList = ref([]);
        const selectedItems = ref([]);
        const corps = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const rptTags = ref([]);
        const rowIndex = ref(null);
        const toast = useToast();
        const loading = ref(false);
        
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 
        const dt2 = ref(); // 데이터 데이블  ref 

        const compCodes = ref([
            {codeNm: '경남도청', code: 1},
        ]);
        const year = ref();
        const calcYms = ref([]);
        //const calcYms = ref(Array.from({ length: 10 }, (_, i) => ({ codeNm: `${2022-i}`, code: 2020-i })));

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                    searchList();
                    break;
                default:
            }
        }

        const searchList = () => {

            // 검색조건의 Calendar에서 선택한 날짜(2019-12-31T15:00:00.000) 또는 문자열(2010-01-01)로 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
            searchParams.sDate = JsUtils.convertDateToString(searchParams.sDate);
            searchParams.eDate = JsUtils.convertDateToString(searchParams.eDate);
            //alert('searchParams = '+ JSON.stringify(searchParams));

            loading.value = true;
            ma601040Service.getList(searchParams).then(data => {
                 if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});               
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const changePublicId= () => {
            custCodes.value = [];

            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            custService.getCodeList(searchParams).then(data => {
                custCodes.value = data;
            });
        }

         // 천단위마다 콤마(,) 표시를 한다
         const formatToPrice = (value) => {
            var num = Number(value).toFixed(0);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, dataList.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(dataList.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, dt2, dataList, selectedItems, searchParams, corps, rowIndex, compCodes, calcYms, year, publicCodes, custCodes, rptTags, loading, isCustUser,
            formatToPrice, changePublicId, btnAct, searchList, downloadExcel, exportCSV, 
        }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
